"use client";

import Image from "next/image";
import React from "react";
import FadeInUp from "@/components/common/ScrollReveal";

export default function OurPartners() {
  return (
    <div className="bg-[#F5F5F5] lg:bg-transparent">
      <FadeInUp effect="fadeInUp">
        <div className="max-w-[90.69vw] sm:max-w-[90.80vw] lg:max-w-[89.58vw] mx-auto py-mob-80 sm:py-tab-90 lg:py-web-97">
          <h4 className="text-mob-22 sm:text-tab-22 lg:text-web-24 leading-[120%] font-medium lg:font-normal text-PrimaryLightBlue mb-[20vw] sm:mb-tab-38 lg:mb-[50px] text-center">
            Our Partner Brands
          </h4>
          <ul className="flex flex-wrap justify-center gap-y-mob-40 sm:gap-y-tab-40 lg:gap-web-90 items-center mb-[20vw] lg:mb-12">
            <li className="w-1/2 lg:w-[calc(100%/7-1.5vw)] flex justify-center">
              <div className="w-[24vw] sm:w-[20vw] lg:w-[6.7vw]">
                <Image
                  src="/images/KNAUF.webp"
                  alt="Knauf Gypsum Board Partner"
                  fill
                  className="!static !h-auto"
                  sizes="(max-width: 991px) 24vw, 7vw"
                />
              </div>
            </li>
            <li className="w-1/2 lg:w-[calc(100%/7-1.5vw)] flex justify-center">
              <div className="w-[34vw] sm:w-[22vw] lg:w-[9.5vw]">
                <Image
                  src="/images/GYPROC.webp"
                  alt="Gyproc Building Materials Partner"
                  fill
                  className="!static !h-auto"
                  sizes="(max-width: 991px) 34vw, 10vw"
                />
              </div>
            </li>
            <li className="w-1/2 lg:w-[calc(100%/7-1.5vw)] flex justify-center">
              <div className="w-[28vw] sm:w-[20vw] lg:w-[9vw]">
                <Image
                  src="/images/JOTUN.webp"
                  alt="Jotun Paints Partner"
                  fill
                  className="!static !h-auto"
                  sizes="(max-width: 991px) 28vw, 9vw"
                />
              </div>
            </li>
            <li className="w-1/2 lg:w-[calc(100%/7-1.5vw)] flex justify-center">
              <div className="w-[28vw] sm:w-[20vw] lg:w-[8vw]">
                <Image
                  src="/images/GTI.svg"
                  alt="GTI Building Solutions Partner"
                  fill
                  className="!static !h-auto"
                  sizes="(max-width: 991px) 28vw, 8vw"
                />
              </div>
            </li>
            <li className="w-1/2 lg:w-[calc(100%/7-1.5vw)] flex justify-center">
              <div className="w-[38vw] sm:w-[25vw] lg:w-[9.5vw]">
                <Image
                  src="/images/geminite.svg"
                  alt="Geminite Building Materials Partner"
                  fill
                  className="!static !h-auto"
                  sizes="(max-width: 991px) 38vw, 10vw"
                />
              </div>
            </li>
          </ul>

          <ul className="flex flex-wrap justify-center gap-y-mob-40 sm:gap-y-tab-40 lg:gap-web-80 items-center ">
            <li className="w-1/3 lg:w-[calc(100%/7-5.20vw)] flex justify-center">
              <div className="w-[15vw] sm:w-[12vw] lg:w-[5.29vw]">
                <Image
                  src="/images/Gpluss.svg"
                  alt="Gplus Partner"
                  fill
                  className="!static !h-auto"
                  sizes="(max-width: 991px) 15vw, 5vw"
                />
              </div>
            </li>
            <li className="w-1/3 lg:w-[calc(100%/7-5.20vw)] flex justify-center">
              <div className="w-mob-100 lg:w-[8.29vw]">
                <Image
                  src="/images/dexone.svg"
                  alt="Dexone Building Systems Partner"
                  fill
                  className="!static !h-auto"
                  sizes="(max-width: 991px) 25vw, 8vw"
                />
              </div>
            </li>
            <li className="w-1/3 lg:w-[calc(100%/7-5.20vw)] flex justify-center">
              <div className="w-mob-100 lg:w-[8.29vw]">
                <Image
                  src="/images/Bosch.webp"
                  alt="Bosch Power Tools Partner"
                  fill
                  className="!static !h-auto"
                  sizes="(max-width: 991px) 25vw, 8vw"
                />
              </div>
            </li>
            <li className="w-1/3 lg:w-[calc(100%/7-5.20vw)] flex justify-center">
              <div className="w-mob-100 lg:w-[8.29vw]">
                <Image
                  src="/images/weber.svg"
                  alt="Weber Construction Partner"
                  fill
                  className="!static !h-auto"
                  sizes="(max-width: 991px) 25vw, 8vw"
                />
              </div>
            </li>
            <li className="w-1/3 lg:w-[calc(100%/7-5.20vw)] flex justify-center">
              <div className="w-mob-65 lg:w-[5.31vw]">
                <Image
                  src="/images/HELNKEL.webp"
                  alt="Henkel Partner"
                  fill
                  className="!static !h-auto"
                  sizes="(max-width: 991px) 20vw, 5vw"
                />
              </div>
            </li>
            <li className="w-1/3 lg:w-[calc(100%/7-5.20vw)] flex justify-center">
              <div className="w-mob-88 lg:w-[7.29vw]">
                <Image
                  src="/images/DeWALT.webp"
                  alt="DeWalt Power Tools Partner"
                  fill
                  className="!static !h-auto"
                  sizes="(max-width: 991px) 25vw, 7vw"
                />
              </div>
            </li>
          </ul>
        </div>
      </FadeInUp>
    </div>
  );
}
